import HttpRequestor from './http_requestor';

export const log = (level, message) => {
  const messageWithURL = `[${window.location.href}] ${message}`;

  console[level](messageWithURL);

  if (!window.logURL) { return; }

  const requestor = new HttpRequestor({ suppressErrors: true });
  requestor.call(window.logURL, 'POST', {
    level,
    messageWithURL
  });
};

export const error = (message) => log('error', message);
export const warn = (message) => log('warn', message);
export const info = (message) => log('info', message);
export const logger = {
  error,
  warn,
  info
};
export default logger;